import { render, staticRenderFns } from "./ModuleTokensValue.vue?vue&type=template&id=ddee4246&scoped=true&"
import script from "./ModuleTokensValue.vue?vue&type=script&lang=js&"
export * from "./ModuleTokensValue.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTokensValue.vue?vue&type=style&index=0&id=ddee4246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddee4246",
  null
  
)

export default component.exports